<template>
	<div>
		<van-nav-bar  left-arrow @click-left="onClickLeft"/>
		<div class="order-head-bg">
			<van-row>
			  <van-col  span="9" >
				  <van-icon name="todo-list-o" />
				  <span style="margin-left: 5px;">{{orderDetail.order_state}}</span>
			  </van-col>
			</van-row>
			<van-row>
			  <van-col offset="2" span="20" class="orderAddress" >  				
				  <div>
					  <b>提货点:</b>
					 <span>{{orderDetail.scene_info.name}}</span> 
				  </div>
				  <div>
					  <b>提货地址:</b>
					  <span>{{orderDetail.scene_info.address}}</span>  
				  </div>
			  </van-col>
			</van-row>
		</div>
		<div class="order-code" v-if="orderDetail.pickup_code">
			<div>取货码</div>
			<div style="color: orangered;">{{orderDetail.pickup_code}}</div>
		</div>
		<div style="text-align: left;padding: 10px 20px;font-size: 14px;">
			<div style="font-weight: 600;font-size: 15px;">订单信息</div>
			<van-divider />
			<van-row>
			  <van-col span="6">订单编号:</van-col>
			  <van-col span="18">{{orderDetail.out_trade_no}}</van-col>
			</van-row>
			<van-row>
			  <van-col span="6">下单时间:</van-col>
			  <van-col span="18">{{orderDetail.create_time}}</van-col>
			</van-row>
			<van-row v-if="orderDetail.pay_time">
			  <van-col span="6">付款时间:</van-col>
			<!--  <van-col span="18">{{timestampToTime(orderDetail.pay_time)}}</van-col> -->
			  <van-col span="18">{{orderDetail.pay_time*1000 | formonment('YYYY-MM-DD HH:mm:ss')}}</van-col>
			</van-row>
			<van-row v-if="orderDetail.pickup_time">
			  <van-col span="6">提货日期:</van-col>
			  <van-col span="18">{{orderDetail.pickup_time*1000 | formonment('YYYY-MM-DD')}}</van-col>
			</van-row>
			<van-row>
			  <van-col span="6">订单备注:</van-col>
			  <van-col span="18">{{orderDetail.attach}}</van-col>
			</van-row>	
		</div>
		<div style="text-align: left;padding: 10px 20px;">
			<div style="font-weight: 600;font-size: 15px; ">商品信息</div>
			<van-card
			  :num="item.quantity"
			  :price="item.amount.toFixed(2)"
			  :desc="item.size ? item.size +'/'+item.unit_name:''"
			  :title="item.name"
			  :thumb="item.thumb_image"
			  v-for="(item,index) in orderDetail.order_detail" :key="index"
			  @click=goProductInfo(item.activity_id)
			/>
			<van-row style="margin: 10px 0;" v-if="orderDetail.pay_time">
			  <van-col span="6"><b>实付款:</b></van-col>
			  <van-col span="18" style="text-align: right;">共<span style="color: orangered;">{{orderDetail.goods_sum}}</span>件商品,金额:￥<span style="color: orangered;">{{orderDetail.total_fee}}</span></van-col>
			</van-row>
			<van-row  v-if="orderDetail.order_state=='待支付'" type="flex" justify="end" style="margin: 20px;">		
				 <van-col span="16" offset="8">
					<van-button plain type="primary" @click="rePay(orderDetail.id)"  round style="margin-right:6px">
					  立即支付
					</van-button> 
					 <van-button plain type="info"  @click="cancelOrder(orderDetail.id)"  round>
					   取消订单
					 </van-button>
				 </van-col>
			</van-row>
		</div>
	</div>
</template>

<script>
	export default{
		name:"orderIng",
		data(){
			return{
				orderDetail:{
					scene_info:{
						name:null,
						address:null
					},
					order_detail:[]
				}
			}
		},
		methods:{
			onClickLeft(){
				this.$router.push({
					path:'/orderList',
					query:{
						name:"待提货"
					}
				})
			},
			//获取订单详情
			getOrderDetail(id){
				var _this =this
			     this.request.postURL('/api/order/orderDetail',{
					id:id
				}).then(function(res){
					_this.orderDetail=res.data.data
				}).catch(function (err) {
				   Toast(err);
				  });
			},
			
			//取消订单
			cancelOrder(id){
				const toast=this.$toast('正在取消');		
				this.request.postURL('/api/order/cancelOrder',{
					id:id
				}).then(res=>{
					this.$router.push({
						path:'/orderList',
						query:{
							name:"待支付"
						}
					})
				}).catch(err=>{
					console.error(err)
					this.$toast("失败");
				})
				
			},
			//未支付订单重新支付
			rePay(id){
				this.$store.dispatch('prePayOrder',id)
			},
			//跳转进入商品详情
			goProductInfo(id){
				this.$router.push({
					path:'/activityInfo',
					query:{
						id:id
					}
				})
			},
			//将时间戳转化为日期时间格式
			timestampToTime(timestamp) {
				var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
				var Y = date.getFullYear() + '-';
				var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
				var D = (date.getDate()+1 < 10 ? '0'+(date.getDate()+1) : date.getDate()+1) + ' ';
				var h = (date.getHours()+1 < 10 ? '0'+(date.getHours()+1) : date.getHours()+1) + ':';
				var m = (date.getMinutes()+1 < 10 ? '0'+(date.getMinutes()+1) : date.getMinutes()+1) + ':';
				var s = (date.getSeconds()+1 < 10 ? '0'+(date.getSeconds()+1) : date.getSeconds()+1);
				return Y+M+D+h+m+s;
			},
		},
		created() {
				var id =this.$route.query.id
				this.getOrderDetail(id)
				
		}
	}
</script>

<style>
	
	.order-head-bg{
		width: 100%;
		height: 60px;
		background-color: coral;
		color: #ffffff;
		padding:20px 0;
		margin-bottom: 80px;
	}
	.orderAddress{
		height: 110px;
		background-color:#ffffff;
		color: #555555;
		border-radius: 8px;
		margin-top: 10px;
		box-shadow:  1px 1px 5px #ccc;
		text-align: left;
		padding: 10px 0 0 20px;
		font-size: 14px;
	}
	.order-code{
		font-size: 30px;
		font-weight: bold;
		margin: 10px 0 0 0 ;
	}
</style>
